import React from 'react';
import ReactDOM from 'react-dom/client';
import './login.css';
import DatabankApp from '../../crowdautomaiton';
import {TableConfig,OptionConfig} from '../../types'

import reportWebVitals from '../../reportWebVitals';
import Login from '../../lubupang/apps/login';
import { Layout } from 'antd';
import HeaderFC from '../../lubupang/components/headerfc';
import { Footer } from 'antd/es/layout/layout';
import FooterFC from '../../lubupang/components/footerfc';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <React.StrictMode>
  <>    <Layout style={{ minHeight: '100vh' }}>
<HeaderFC showmenu={false}/>

<Layout >
{window.innerWidth>=720? <Login />:<>为了您的体验请使用分辨率大于720的设备访问本网站</>}

  

  
</Layout>
<FooterFC showmenu={false}/>
</Layout>
</>

  </React.StrictMode>
)


